<template>
    <transition name="fade">
        <div class="dd-screen" v-if="disclaimerVisible && !this.mobileBrowser">
            <div class="dd-container">
                <div class="dd-wrapper">
                    <div class="dd-icon">
                        <img src="@/assets/disclaimer.png" alt="" width="80px" height="80px">
                    </div>
                    <div class="dd-text">
                        <div class="dd-text-header">Achtung!</div>
                        <div class="dd-text-body">
                            Wenn Sie sich im Videochat befinden, wird die Audiospur Ihrer Gesprächspartner über das Standardkommunikationsgerät übertragen.
                            Stellen Sie daher sicher, dass Ihr standard Audioausgabegerät auch Ihr Standardkommunikationsgerät ist.<br><br>
                            Hier eine Anleitung, wie Sie das Standardkommunikationsgerät ändern können:
                        </div>
                        <a href="https://www.mcbsys.com/blog/2018/09/set-default-communications-device-in-windows-10-1803" class="dd-text-list-title">https://www.mcbsys.com/blog/2018/09/set-default-communications-device-in-windows-10-1803/</a>
                    </div>                
                    <div class="dd-button">
                        <md-button @click="toggleDialogue">Verstanden</md-button>
                    </div>
                </div>
            </div>
            <div class="sd-background" @click="toggleDialogue"></div>
        </div>
    </transition>
</template>

<style>
    .dd-screen{
        width: 100%;
        height: 100%;
        position: relative;
        z-index: 99999;
    }
    .dd-background{
        width: 100%;
        height: 100%;
        position: absolute;
        background: #00000079;   
    }
    .dd-container{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%); 
        z-index: 6;
    }
    .dd-wrapper{        
        width: 550px;
        background: white;
        border-radius: 10px;
        padding: 20px;
        color: rgb(39, 39, 39);
        position: relative;
    }
    .dd-text-header{
        font-size: 25px;
        margin-bottom: 20px;
        margin-top: 20px;
        color: black;
        text-align: center;
    }
    .dd-text-body{
        display:block;
        font-size: 17px;
        margin-bottom: 10px;
    }
    .dd-wrapper .md-button{
        background-color: var(--primaryColor);
        border-radius: 4px;
        margin: 0;
        --md-theme-default-text-primary-on-background: white;
    }
    .dd-button{
        text-align: center; 
        margin-top: 30px;
    }
    .dd-icon{
        text-align: center;
    }
    /* MOBILE */
    @media (max-device-width: 900px){
        .dd-icon img{
            width: 50px;
            height: 50px;
        }
        .dd-wrapper{  
            width: 100%; 
            padding: 15px;
        }
        @media (orientation:portrait){
            .dd-container{
                width: 95%; 
            }
        }
        @media (orientation:landscape){
            .dd-icon img{
                width: 40px;
                height: 40px;
            }
            .dd-text-header{
                margin-bottom: 10px;
                margin-top: 10px;
            }
            .dd-wrapper{  
                height: 80%;       
                width: 550px;
                padding: 15px;
                padding-top: 10px;
                padding-bottom: 10px;
            }
            .dd-button{
                margin-top: 15px;
            }
        }   
    }
</style>
    
<script>
export default {
    name: 'disclamer-dialogue',
    inject: ['toggleSharing'],
    data: () => ({
        disclaimerVisible: false,
        mobileBrowser: false,
    }),
	methods: {
        toggleDialogue(){
            this.disclaimerVisible = !this.disclaimerVisible;
        }
    },
    mounted: function(){
       if( screen.width < 900)
        this.mobileBrowser = true;
    }
}

</script>